import { useRef } from 'react';
import { Constructable, IComponentOptions } from 'tsdi';

import { tsdiInjector } from './tsdi-injector';

export type TsdiDependency<T> = string | Constructable<T>;

function getComponentOptions<T>(
    Dependency: TsdiDependency<T>
): IComponentOptions {
    const componentOptions: IComponentOptions | undefined =
        typeof Dependency !== 'string' &&
        Reflect.getMetadata('component:options', Dependency);

    return componentOptions || {};
}

export function injectTSDI<T>(Dependency: TsdiDependency<T>, hint?: string): T {
    const componentOptions = getComponentOptions(Dependency);

    if (componentOptions.singleton === false) {
        throw new Error(
            'The option { singleton: false } will not work with `injectTSDI`. Please use `useTSDI` when inside a react-component or use the @inject-decorator in classes.'
        );
    }

    return tsdiInjector.get(Dependency, hint);
}

export function useTSDI<T>(Dependency: TsdiDependency<T>, hint?: string): T {
    const dep = tsdiInjector.get(Dependency, hint);
    const depState = useRef(dep);

    const componentOptions = getComponentOptions(Dependency);

    if (componentOptions.singleton === false) {
        return depState.current;
    }

    return dep;
}
